import { lazy } from 'react';

const CostCentersPage = lazy(() => import('../pages/CostCenters.page'));

const CostCentersRoutes = [
    {
        path: '/cost-centers',
        element: <CostCentersPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { CostCentersRoutes };
